import { render, staticRenderFns } from "./CustomerHistory.vue?vue&type=template&id=0d3c7c44&scoped=true"
import script from "./CustomerHistory.vue?vue&type=script&lang=js"
export * from "./CustomerHistory.vue?vue&type=script&lang=js"
import style0 from "./CustomerHistory.vue?vue&type=style&index=0&id=0d3c7c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3c7c44",
  null
  
)

export default component.exports